import withHits from "../sessionType/withHits.js";
import sessionClassifierBuilder from "./sessionClassifierBuilder.js";

const sessionWithHit = sessionClassifierBuilder(
    withHits, undefined, undefined
);

export default sessionWithHit;